export const convertToDateFormat = (isoDate: string | Date, locale: string = navigator.language): string => {
    // const date = new Date(isoDate);
    // const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
    // const day = date.getDate().toString().padStart(2, '0');
    // const year = date.getFullYear().toString();

    // return `${month}-${day}-${year}`;
    return new Date(isoDate).toLocaleDateString(locale, {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    });
}
